import { ReactNode } from 'react';

import { Modal } from './Modal';
import { t } from '../../services/translation/translation';
import { DangerButton } from '../button/DangerButton';
import { GradientButton } from '../button/GradientButton';
import { PrimaryButton } from '../button/PrimaryButton';
import { SecondaryButton } from '../button/SecondaryButton';

type Props = {
  type?: 'primary' | 'danger' | 'gradient';
  title: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onClose: () => void;
  onConfirm?: () => void;
  children: ReactNode;
  isLoading?: boolean;
  form?: string;
};

export const ConfirmationModal = ({
  title,
  type = 'primary',
  confirmLabel,
  cancelLabel,
  children,
  isLoading,
  onClose,
  onConfirm,
  form,
}: Props) => {
  const ConfirmButton = type === 'danger' ? DangerButton : type === 'gradient' ? GradientButton : PrimaryButton;

  return (
    <Modal onClose={onClose}>
      <Modal.Header onClose={onClose} title={title} />
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <SecondaryButton onClick={onClose}>{cancelLabel || t('common.cancel')}</SecondaryButton>
        <ConfirmButton
          onClick={form ? undefined : onConfirm}
          isLoading={isLoading}
          form={form}
          type={form ? 'submit' : 'button'}
        >
          {confirmLabel || t('common.confirm')}
        </ConfirmButton>
      </Modal.Footer>
    </Modal>
  );
};
